import { Button } from '@artosera/ui';
import { formatDate } from '@artosera/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useDossiersOeuvres,
  useOuvrirDossierPdf,
  useArchiverDossierOeuvres,
} from '../../api/dossiersOeuvres.js';
import { estApiError } from '../../api/errors.js';
import { ouvrirUrlSignee } from '../../api/client.js';
import { DossierOeuvresDialog } from '../oeuvres/DossierOeuvresDialog.js';
import styles from '../oeuvres/DossierOeuvresDialog.module.css';
export function DossiersOeuvresSection({
  galerieSlug: g,
  contactId,
  contactNom,
  peutEcrire,
}: {
  galerieSlug: string;
  contactId: string;
  contactNom: string;
  peutEcrire: boolean;
}) {
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const tr = (k: string, v?: Record<string, unknown>) => t(`regie:dossiersOeuvres.${k}`, v);
  const liste = useDossiersOeuvres(g, { contactId }),
    pdf = useOuvrirDossierPdf(g),
    archiver = useArchiverDossierOeuvres(g);
  const [open, setOpen] = useState(false),
    [erreur, setErreur] = useState<string | null>(null);
  async function ouvrir(id: string) {
    setErreur(null);
    try {
      ouvrirUrlSignee((await pdf.mutateAsync(id)).url);
    } catch (e) {
      setErreur(estApiError(e) ? e.message : t('commun:erreurReseau'));
    }
  }
  return (
    <section className={styles.formulaire} data-ui="contact-portfolios">
      <h2>{tr('titre')}</h2>
      {liste.isLoading ? (
        <p>{t('commun:chargement')}</p>
      ) : liste.isError ? (
        <p role="alert">
          {estApiError(liste.error) ? liste.error.message : t('commun:erreurReseau')}
        </p>
      ) : !liste.data?.dossiers.length ? (
        <p>{tr('vide')}</p>
      ) : (
        <ul className={styles.selection}>
          {liste.data.dossiers.map((d) => (
            <li key={d.id}>
              <strong>{d.titre}</strong>
              <p className={styles.meta}>
                {formatDate(new Date(d.creeLe), i18n.language === 'en' ? 'en' : 'fr', 'court')} ·{' '}
                {tr('nombre', { count: d.oeuvres.length })}
              </p>
              <div className={styles.gestes}>
                <Button
                  variant="secondary"
                  loading={pdf.isPending}
                  onClick={() => void ouvrir(d.id)}
                >
                  {tr('telecharger')}
                </Button>
                {peutEcrire && (
                  <Button
                    variant="ghost"
                    loading={archiver.isPending}
                    onClick={() => {
                      void archiver
                        .mutateAsync(d.id)
                        .catch((e) =>
                          setErreur(estApiError(e) ? e.message : t('commun:erreurReseau')),
                        );
                    }}
                  >
                    {tr('archiver')}
                  </Button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
      {peutEcrire && (
        <Button variant="secondary" onClick={() => setOpen(true)}>
          {tr('preparer')}
        </Button>
      )}
      {erreur && <p role="alert">{erreur}</p>}
      {open && (
        <DossierOeuvresDialog
          open
          onOpenChange={setOpen}
          oeuvreIds={[]}
          contactInitial={{ id: contactId, nom: contactNom }}
        />
      )}
    </section>
  );
}
